import type { TTerm } from '@/types'
import { LOCALES } from '@/common'
import { SOURCES, TAGS, TYPES } from '@/data/raw'

export default {
  id: `posthog`,

  name: {
    [LOCALES.EN_US]: `PostHog`,
  },

  label: {
    [LOCALES.EN_US]: ``,
  },

  definition: {
    [LOCALES.EN_US]: ``,
  },

  type: [TYPES.service, TYPES.platform],

  tags: [],
} as const satisfies TTerm
